<ae-view-template
  (closeDialog)="close()"
  [isDialog]=true
  [templateId]="templateId">
</ae-view-template>
